import React, { Component } from "react";
import { getPosts, getTopics } from "./../../services/posts";
import { getForumCats } from "./../../services/forumcategories";
import { Box } from "@material-ui/core";
import CategoryTable from "./CategoryIndex";
// import Spinner from "../../components/spinner";
// import Layout from "../../components/common/Layout";
import NavigateMenu from "./NavigateMenu";
import HeaderTable2 from "./HeaderTable2";

// Component of ForumHome..
class ForumHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      forumsubcats: [],
      topicsResult: [],
      lastName: "",
      lastUpdated: "hi",
      forumcats: [],
      forumId: "",
      forumCatName: "",
      loading: false,
    };
  }

  // Get forum categories..
  async getForumCategories() {
    this.setState({
      loading: true,
    });

    try {
      const { data: forumcats } = await getForumCats();
      const comments = await getPosts();

      const topics = forumcats.map((e) => {
        if (e.lastTopic && e.lastTopic !== "") {
          const replies = comments.data.filter(
            (element1) => element1.topicId?._id === e._id
          ).length;
          const topicsWithReplies = { ...e.lastTopic, replies };

          return topicsWithReplies;
        } else {
          return null;
        }
      });

      this.setState({
        forumcats,
        topicsResult: topics,
      });
      this.setState({
        loading: false,
      });
    } catch (error) {
      console.error(error);
      this.setState({
        loading: false,
      });
    }
  }

  // After loadPage we will get Posts data also..
  // async loadPage() {
  //   const { data: apiGetTopics } = await getTopics();

  //   if (apiGetTopics.length == 0) {
  //     this.setState({ lastUpdated: "" });
  //   } else {
  //     apiGetTopics.forEach((element) => {
  //       element.createdAt = new Date(element.createdAt)
  //         .toString()
  //         .substring(4, 15);

  //       element.updatedAt = new Date(element.updatedAt)
  //         .toString()
  //         .substring(4, 15);
  //     });

  //     let total = 0;
  //     apiGetTopics.forEach((element) => {
  //       let userReply = element.userReply ? element.userReply.length : 0;
  //       total = total + userReply;
  //     });
  //     this.setState({ topicsResult: apiGetTopics });
  //     this.setState({ lastName: apiGetTopics[0].user.username });
  //     this.setState({ lastUpdated: apiGetTopics[0].updatedAt });
  //   }
  // }

  // Calling all async functions..
  async componentDidMount() {
    document.title = "Forum";    
    await this.getForumCategories();
    // await this.loadPage();
  }

  // The Render Method..
  render() {
    // Necessary States..
    const { forumcats, loading, topicsResult } = this.state;

    return !loading && <Box mt={15} mb={15} className="container">
      <NavigateMenu />
      <HeaderTable2 getforumCategories={this.getforumCategories} />
      <CategoryTable categoriesData={forumcats} latestData={topicsResult} />
    </Box>;
  }
}

export default ForumHome;
